import { parseISO } from "date-fns";
import { maskModeColorMapping, planningModeColorMapping } from "shared/enums/colorMappings/globalColorMappings";

import { FinlandPlanningMaskModeEnum, FrancePlanningMaskModeEnum, PlanningModeEnum } from "shared/enums/globalEnums";
import { ModeType, PlanningOrMaskType } from "shared/types";

type GraphType = "Plannings" | "Masks";
type ItemModeKeyType =
  | keyof typeof PlanningModeEnum
  | keyof typeof FrancePlanningMaskModeEnum
  | keyof typeof FinlandPlanningMaskModeEnum;

/**
 * Generic function to get color based on the mode.
 * @param mode The mode key which is a type of the enum.
 * @param colorMap The dictionary of colors corresponding to the mode enum.
 */
export const getColorByMode = (colorMap: ModeType, mode: ItemModeKeyType): string => {
  return colorMap[mode] || "red"; // Default color is red if not found.
};

const getGraphTypeInfos = (graphType: GraphType) => {
  return {
    modeKeys:
      graphType === "Plannings"
        ? { ...PlanningModeEnum }
        : { ...FrancePlanningMaskModeEnum, ...FinlandPlanningMaskModeEnum },
    modeLabel: graphType === "Plannings" ? "mode" : "operating_mode",
    colorMap: graphType === "Plannings" ? planningModeColorMapping : maskModeColorMapping,
  };
};

export function generateChartDatasets(items: PlanningOrMaskType[], graphTypeLabel: GraphType) {
  const { modeKeys, modeLabel, colorMap } = getGraphTypeInfos(graphTypeLabel);
  return (Object.keys(modeKeys) as ItemModeKeyType[]).map((mode) => {
    const filteredItems = items.filter((item: PlanningOrMaskType) => item[modeLabel] === mode);
    const data = filteredItems.map(({ overidable, start_date, end_date, ...rest }: PlanningOrMaskType) => ({
      x: [parseISO(start_date as string), parseISO(end_date as string)],
      y: graphTypeLabel,
      overridable: graphTypeLabel === "Plannings" && overidable,
      ...rest,
    }));
    const backgroundColor = getColorByMode(colorMap, mode);

    return {
      label: mode,
      data,
      backgroundColor,
      barThickness: 60,
      borderRadius: 5,
      borderSkipped: false,
      borderColor: (context: any) => {
        if (!context?.raw?.overridable) return "red";
        return graphTypeLabel === "Plannings" ? "black" : undefined;
      },
      borderWidth: graphTypeLabel === "Plannings" ? 2 : undefined,
    };
  });
}
